const calculatorDataStore = require("./calculatorDataStore");

/**
 * @return {null | RoiCalculatorFormData}
 */
module.exports = function getSavedCalculatorData() {
    return calculatorDataStore.data;
}